import { defineStore } from 'pinia';
import { markRaw, ref } from 'vue';

/* Pila di modali con esito restituito come Promise.
 *
 * Sostituisce `$buefy.modal.open` (7 chiamate) e soprattutto l'idioma
 * `$parent.close()`, usato 13 volte in 6 file: ogni contenuto di modale
 * doveva conoscere il proprio genitore per chiudersi, e non c'era modo di
 * sapere *come* si era chiusa. Buefy inoltre non aveva un `dialog.confirm`
 * sostituibile in Vue 3 (Oruga non ha il modulo dialog), quindi le conferme
 * sono anch'esse modali di questa pila.
 *
 * Qui `open()` restituisce una Promise che si risolve con il valore passato a
 * `close()`, o con `undefined` se l'utente annulla. Il chiamante può quindi
 * scrivere `const salvato = await modals.open(PinEditor, {...})`.
 */
export const useModalStore = defineStore('modals', () => {
  const stack = ref([]);
  let nextId = 1;

  function open(component, props = {}) {
    return new Promise((resolve) => {
      stack.value = [
        ...stack.value,
        // markRaw: un componente non deve diventare reattivo.
        { id: nextId++, component: markRaw(component), props, resolve },
      ];
    });
  }

  function close(id, result) {
    const entry = stack.value.find((item) => item.id === id);
    if (!entry) return;
    stack.value = stack.value.filter((item) => item.id !== id);
    entry.resolve(result);
  }

  /** Chiude la modale in cima, per il tasto Esc e il clic sullo sfondo. */
  function closeTop(result) {
    const top = stack.value.at(-1);
    if (top) close(top.id, result);
  }

  return { stack, open, close, closeTop };
});
